import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataManagement } from '../components/PrivacyConsent';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const DataManagementPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-bg to-fg/5 py-20">
      <div className="container mx-auto px-6 max-w-2xl">
      <Link
        to="/"
        className="relative z-[9999] inline-flex items-center gap-2 text-primary mb-6 hover:underline cursor-pointer">
        <ArrowLeft size={20} />
        {t('backToHome')}
      </Link>
        
        <div className="bg-white dark:bg-fg/10 rounded-2xl shadow-xl p-8">
          <h1 className="text-3xl font-bold mb-2">{t('manageMyData')}</h1>
          <p className="text-fg/60 mb-6">{t('manageDataDesc')}</p>
          
          {!isSubmitted ? (
            <div className="space-y-4">
              <label className="block text-sm font-medium text-fg/80">
                {t('enterEmailToManage')}
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="w-full px-4 py-2 border border-fg/10 rounded-lg bg-white dark:bg-fg/10"
              />
              <button
                onClick={() => setIsSubmitted(true)}
                className="w-full py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition"
              >
                {t('continue')}
              </button>
            </div>
          ) : (
            <DataManagement userEmail={email} onClose={() => setIsSubmitted(false)} />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DataManagementPage;